import { createFileRoute } from "@tanstack/react-router";
import Solutions from "@/pages/Solutions";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/zh/solutions")({
  head: () => pageHead("/solutions", "zh"),
  component: Solutions,
});
